module.exports = __webpack_public_path__ + "img/googleplay.4263a06f.png";